import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export const TOAST_TIME_OUT = 3000;

const showToast = (message: string, type: 'success' | 'error' | 'warn' | 'info', params: object): void => {
  toast[type](message, {
    position: 'top-right',
    autoClose: TOAST_TIME_OUT,
    ...params,
  });
};

export const showSuccessToast = (message: string, params: object = {}): void => showToast(message, 'success', params);
export const showErrorToast = (message: string, params: object = {}): void => showToast(message, 'error', params);
export const showWarningToast = (message: string, params: object = {}): void => showToast(message, 'warn', params);
export const showInfoToast = (message: string, params: object = {}): void => showToast(message, 'info', params);
